import { cn } from "@/lib/utils";
import { Text } from "components/core/Text";
import { ComponentProps } from "react";

export const ContentAbstract = ({
    className,
    ...props
}: Omit<ComponentProps<typeof Text>, "variant">) => {
    return (
        <Text
            className={cn("line-clamp-1 break-all", className)}
            variant="body4"
            color="text.secondary"
            {...props}
        />
    );
};
